import type { Entry } from "../types";

export const reviewSubmissionMessages = {
  newReviewIntro: {
    ko: "광고 유형과 기본 정보를 입력하고 검토할 자료를 업로드하면 컴플라이언스 검토가 시작됩니다.",
    en: "Choose the advertising format, add the details, and upload the material to start a compliance review.",
  },
  reviewProgress: { ko: "검토 진행 상태", en: "Review progress" },
  reviewStepDetails: { ko: "광고 정보", en: "Details" },
  reviewStepUpload: { ko: "자료 업로드", en: "Upload" },
  reviewStepConfirm: { ko: "확인, 제출", en: "Confirm" },
  chooseChannel: { ko: "검토할 광고 유형을 선택하세요", en: "Choose the advertising channel" },
  chooseChannelHelp: {
    ko: "자료가 게시될 매체를 선택하면 해당 유형에 맞는 기준으로 검토합니다.",
    en: "Pick where the material will run so it is checked against the right criteria.",
  },
  chooseMaterialCategory: {
    ko: "검토할 자료 구분을 선택하세요",
    en: "Choose the material category",
  },
  reviewMetadata: { ko: "검토 기본 정보", en: "Review details" },
  requiredFieldNotice: { ko: "* 표시는 필수 입력 항목입니다.", en: "Fields marked * are required." },
  reviewUpload: { ko: "검토 자료 업로드", en: "Upload review material" },
  reviewUploadHelp: {
    ko: "정확한 검토를 위해 실제 게시할 최종 자료를 PDF, 이미지 또는 TXT 파일로 업로드해 주세요.",
    en: "Upload the final material intended for publication as a PDF, image, or TXT file.",
  },
  reviewUploadDropzone: {
    ko: "PDF, JPG/JPEG, PNG 또는 TXT 파일을 여기에 끌어다 놓거나 선택하세요.",
    en: "Drag and drop a PDF, JPG/JPEG, PNG, or TXT file here, or choose a file.",
  },
  reviewFileRequirements: {
    ko: "PDF, PNG, JPG/JPEG, TXT",
    en: "PDF, PNG, JPG/JPEG, TXT",
  },
  // Shared by the initial submission and resubmission so the two cannot state
  // different limits. Kept in step with REVIEW_ACCEPTED_EXTENSIONS and
  // REVIEW_MAX_FILE_BYTES, which is what actually enforces them.
  reviewMaterialRequirements: {
    ko: "PDF, PNG, JPG/JPEG, TXT ,  최대 20MB",
    en: "PDF, PNG, JPG/JPEG, TXT ,  up to 20 MB",
  },
  unknownFileType: { ko: "파일", en: "File" },
  removeFile: { ko: "파일 제거", en: "Remove" },
  confirmReview: { ko: "제출 내용 확인", en: "Confirm submission" },
  confirmReviewHelp: {
    ko: "제출 후 분석이 시작됩니다. 아래 내용을 마지막으로 확인해 주세요.",
    en: "Analysis starts after submission. Check the details below.",
  },
  submissionLifecycleNote: {
    ko: "제출된 자료는 분석 후 컴플라이언스 담당자의 최종 결정을 기다립니다. 진행 상태는 상세 화면에서 확인할 수 있습니다.",
    en: "Submitted material is analyzed, then awaits a compliance officer’s final decision. Track progress on the detail page.",
  },
  previous: { ko: "이전", en: "Previous" },
  next: { ko: "다음", en: "Next" },
  submitReview: { ko: "검토 요청 제출", en: "Submit review" },
  submittingReview: { ko: "검토 요청 제출 중...", en: "Submitting review..." },
  fileRequired: { ko: "검토할 파일을 선택하세요.", en: "Choose a file to review." },
  fileTypeInvalid: { ko: "지원하지 않는 파일 형식입니다.", en: "This file type is not supported." },
  reviewFileTooLarge: { ko: "검토 자료는 20MB 이하여야 합니다.", en: "Review material must be 20 MB or smaller." },
  fileEmpty: { ko: "내용이 없는 파일은 제출할 수 없습니다.", en: "An empty file cannot be submitted." },
  pdfTypeInvalid: {
    ko: "확장자는 PDF이지만 실제 PDF 파일이 아닙니다.",
    en: "The file has a PDF extension but is not a PDF.",
  },
  lifecycleDRAFT: { ko: "아직 제출되지 않은 초안입니다.", en: "This review is still a draft." },
  lifecycleSUBMITTED: { ko: "자료가 제출되어 분석을 기다리고 있습니다.", en: "The material was submitted and is waiting for analysis." },
  lifecycleANALYZING: { ko: "정책과 규칙을 기준으로 자료를 분석하고 있습니다.", en: "The material is being analyzed against policies and rules." },
  lifecycleAWAITING_DECISION: { ko: "분석이 완료되어 담당자의 결정을 기다리고 있습니다.", en: "Analysis is complete and awaiting an officer decision." },
  lifecycleSELF_CHECK_COMPLETE: { ko: "사전 검토가 명확한 결과로 완료되었습니다. 이는 법적 승인이 아닙니다.", en: "The self-check completed with a clear result; this is not legal approval." },
  lifecycleSELF_CHECK_REJECTED: {
    ko: "사전 검토가 자동 반려로 완료되었습니다. 이는 법적 반려가 아니며, 수정 후 다시 제출할 수 있습니다.",
    en: "The self-check completed as an automatic reject; this is not a legal rejection. You can revise and resubmit.",
  },
  lifecycleDECIDED: { ko: "담당자의 결정이 기록되었습니다.", en: "The officer’s decision has been recorded." },
  analysisProgressTitle: { ko: "AI 컴플라이언스 검사", en: "AI compliance checks" },
  analysisProgressActive: { ko: "진행 중", en: "in progress" },
  analysisProgressRecent: { ko: "최근 완료", en: "recently completed" },
  analysisProgressQueued: { ko: "검사 순서를 기다리는 중", en: "Waiting for an available worker" },
  analysisProgressUploading: { ko: "자료를 업로드하는 중", en: "Uploading the material" },
  analysisProgressUploadingPercent: {
    ko: "자료를 업로드하는 중 ({percent}%)",
    en: "Uploading the material ({percent}%)",
  },
  analysisProgressProcessingUpload: {
    ko: "업로드 완료, 서버에서 처리하는 중",
    en: "Upload complete, processing on the server",
  },
  analysisProgressExpand: { ko: "실시간 워크플로 펼치기", en: "Expand live view" },
  analysisProgressIndexing: { ko: "업로드한 자료를 읽고 인덱싱하는 중", en: "Reading and indexing the uploaded material" },
  analysisProgressPreparing: { ko: "적용할 규칙과 문서를 준비하는 중", en: "Preparing applicable rules and documents" },
  analysisProgressDeterministic: { ko: "필수 문구와 금지 표현을 검사하는 중", en: "Checking required wording and prohibited expressions" },
  analysisProgressAnalyzing: { ko: "AI가 정책과 규칙을 기준으로 검사하는 중", en: "AI is checking policies and rules" },
  analysisProgressSinglePassNote: {
    ko: "AI는 아래 모든 항목을 한 번에 함께 검토합니다 (규칙별로 순차 진행되지 않음). 최대 2분 정도 걸릴 수 있습니다.",
    en: "AI reviews everything below together in one pass (not one rule at a time) — this can take up to 2 minutes.",
  },
  analysisProgressFinalizing: { ko: "결과를 검증하고 분류하는 중", en: "Validating and classifying results" },
  analysisProgressComplete: { ko: "검사 완료", en: "Check complete" },
  analysisProgressFailed: { ko: "자동 검사를 완료하지 못해 담당자 검토로 전환됨", en: "Automatic check could not finish; routed to an officer" },
  analysisProgressStages: { ko: "검사 단계", en: "Check stages" },
  analysisProgressSourceCounts: {
    ko: "맞춤 규칙 {customRules}개 ,  세이지 학습 {lessons}개 ,  문서 {policies}개 ,  금지 표현 {dictionaryEntries}개",
    en: "{customRules} custom rules ,  {lessons} lessons ,  {policies} documents ,  {dictionaryEntries} dictionary entries",
  },
  analysisScopeAllMaterials: { ko: "전체 자료", en: "All materials" },
  analysisScopeNudgeTitle: {
    ko: "{channel}에 정책, 규칙 {count}개가 연결되어 있습니다",
    en: "{count} policies and rules are connected to {channel}",
  },
  analysisScopeNudgeBody: {
    ko: "현재 대상은 {target}입니다. 연결 범위가 넓을수록 검사 항목도 늘어납니다. 채널과 자료에 필요한 항목만 연결하면 다음 검사가 더 빠르고 결과도 더 간결해집니다.",
    en: "Current target: {target}. A wider connection scope creates more checks. Connect only the items relevant to each channel and material to make future checks faster and results easier to review.",
  },
  analysisScopeMapTitle: { ko: "연결된 검사 범위", en: "Connected check scope" },
  analysisScopeMapHint: { ko: "한 칸 = 정책, 규칙 1개", en: "One tile = one policy or rule" },
  analysisScopeDictionaryNote: {
    ko: "금지 표현 {count}개는 공통 사전으로 별도 검사됩니다.",
    en: "{count} prohibited expressions are checked separately as a shared dictionary.",
  },
  analysisScopeReviewLink: { ko: "연결 범위 검토", en: "Review connections" },
  analysisProgressElapsed: { ko: "경과 {time}", en: "{time} elapsed" },
  analysisProgressSources: { ko: "검사 대상 보기", en: "View sources being checked" },
  analysisProgressAwaitingResult: { ko: "결과 대기", en: "Awaiting result" },
  analysisProgressOpen: { ko: "상세 보기", en: "Open details" },
  analysisProgressMinimize: { ko: "진행 패널 최소화", en: "Minimize progress panel" },
  analysisProgressRestore: { ko: "진행 패널 열기", en: "Open progress panel" },
  analysisProgressClearCompleted: { ko: "완료 항목 지우기", en: "Clear completed" },
  analysisProgressUpdated: { ko: "방금 상태를 확인했습니다.", en: "Status checked just now." },
  analysisProgressEta: { ko: "약 {time} 남음", en: "~{time} remaining" },
  analysisProgressEtaUnknown: { ko: "예상 소요 시간 계산 중", en: "Estimating time remaining" },
  analysisProgressActiveBadge: { ko: "진행 중인 AI 검사 {count}건", en: "{count} AI check(s) in progress" },
  analysisProgressLessonTestBadge: { ko: "세이지 가르치기 검증", en: "Lesson test" },
  analysisToastCompleted: {
    ko: "'{title}' 검토의 AI 컴플라이언스 검사가 완료되었습니다.",
    en: "AI compliance check finished for '{title}'.",
  },
  analysisToastFailed: {
    ko: "'{title}' 검토의 자동 검사를 완료하지 못해 담당자 검토로 전환되었습니다.",
    en: "The automatic check for '{title}' could not finish and was routed to an officer.",
  },
  analysisToastView: { ko: "열기", en: "View" },
  preliminaryFindingsBanner: {
    ko: "AI 검사가 진행 중입니다. 아래는 필수 문구, 금지 표현 검사에서 먼저 발견된 예비 결과이며, AI 검사가 끝나면 추가되거나 갱신될 수 있습니다.",
    en: "The AI check is still running. These are preliminary results from the required-wording and prohibited-expression checks — more findings may be added once the AI check finishes.",
  },
  revisionHistory: { ko: "자료 버전 기록", en: "Revision history" },
  revisionHistoryHelp: {
    ko: "제출한 버전을 확인하고 이전 자료와 비교할 수 있습니다.",
    en: "Inspect submitted versions and compare them with earlier material.",
  },
  viewRevision: { ko: "확인할 버전", en: "View version" },
  compareWith: { ko: "비교할 버전", en: "Compare with" },
  noComparison: { ko: "비교 안 함", en: "No comparison" },
  createdAt: { ko: "등록 시각", en: "Created" },
  noBodyText: { ko: "이 버전에는 입력된 본문이 없습니다.", en: "This version has no entered copy." },
  revisionTextChanged: { ko: "두 버전의 광고 본문이 다릅니다.", en: "The advertising copy differs between these versions." },
  revisionTextUnchanged: { ko: "두 버전의 광고 본문은 같습니다.", en: "The advertising copy is unchanged." },
  findingsHelp: {
    ko: "각 지적 사항의 실제 광고 문구, 판단 근거와 권고 수정안을 확인하세요.",
    en: "Review the material quote, source, and suggested revision for each finding.",
  },
  materialEvidence: { ko: "광고 자료 내 증거", en: "Material evidence" },
  correctionChecklist: { ko: "수정 요청 체크리스트", en: "Correction checklist" },
  correctionChecklistHelp: {
    ko: "재제출 전에 반영한 항목을 모두 확인해 주세요.",
    en: "Confirm every item addressed before resubmitting.",
  },
  correctionsRequired: {
    ko: "조건부 승인 또는 반려 시 필수 수정 요청을 입력하세요.",
    en: "Required corrections are needed for approval with changes or rejection.",
  },
  resubmitHelp: {
    ko: "수정 사항을 반영한 새 버전을 제출하면 다시 분석됩니다.",
    en: "Submit a corrected version to start a new analysis.",
  },
  replacementFile: { ko: "교체 파일 (선택)", en: "Replacement file (optional)" },
  resubmitNeedsChanges: {
    ko: "현재 버전과 다른 본문, 채널 또는 새 파일이 필요합니다.",
    en: "Change the copy or channel, or attach a new file.",
  },
  correctionChecklistRequired: {
    ko: "모든 필수 수정 항목을 확인해 주세요.",
    en: "Confirm all required correction items.",
  },
  resubmitConfirmation: {
    ko: "수정된 자료가 실제 게시 예정인 최종본이며, 재분석이 시작됨을 확인합니다.",
    en: "I confirm this is the corrected final material and understand reanalysis will begin.",
  },
  resubmitConfirmRequired: {
    ko: "재제출 확인 항목에 동의해 주세요.",
    en: "Confirm the resubmission statement.",
  },
  resubmitting: { ko: "재제출 중...", en: "Resubmitting..." },
  // Dashboard
} as const satisfies Record<string, Entry>;
